export const OFF_SEASON_OFFER_TYPE = 'off_season'
